module.exports = __webpack_public_path__ + "static/media/sch-3.6b193ccb.jpg";